module.exports = __webpack_public_path__ + "static/media/2.bbbf649b.png";